import { render, staticRenderFns } from "./package-image-crop.vue?vue&type=template&id=45ad0578&"
import script from "./package-image-crop.vue?vue&type=script&lang=js&"
export * from "./package-image-crop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports